var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-form-model',{staticStyle:{"max-width":"500px","margin":"40px auto 0"}},[_c('a-result',{attrs:{"title":"返回结果","status":"success","subTitle":"点击【返回房源列表】即可在列表中查看新添加的房源信息。"}},[_c('template',{slot:"extra"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.finish}},[_vm._v("继续添加")]),_c('a-button',{staticStyle:{"margin-left":"8px"},on:{"click":_vm.toHouseList}},[_vm._v("返回房源列表")])],1),_c('div',{staticClass:"desc"},[_c('p',{staticStyle:{"font-size":"16px"}},[_c('strong',[_vm._v("具体房源上传结果如下：")])]),_vm._l((_vm.result),function(item,idx){return _c('p',{key:idx},[_c('a-icon',{style:({
              color:
                item.code == 0 ? 'green' : item.code == 1 ? 'red' : 'orange'
            }),attrs:{"type":item.code == 0
                ? 'check-circle'
                : item.code == 1
                ? 'close-circle'
                : 'exclamation-circle'}}),_c('a',[_vm._v(_vm._s(item.houseName)+">")]),_c('span',{style:({
              color:
                item.code == 0 ? 'green' : item.code == 1 ? 'red' : 'orange'
            })},[_vm._v(_vm._s(item.message))])],1)})],2)],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }